"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobAreaSelectField = JobAreaSelectField;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const elements_1 = require("@src/components/elements");
const Api = __importStar(require("@src/api"));
const normalize_string_1 = require("@src/helpers/normalize-string");
const { Option } = elements_1.Select;
const SelectFieldWrapper = (props) => {
    const { jobAreas, useIdAsValue, value, onChange, defaultValue, intl, ...otherProps } = props;
    const onSelectChange = (ids) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(ids.map(id => jobAreas.find(jobArea => jobArea.id === id)));
    };
    return ((0, jsx_runtime_1.jsx)(elements_1.Select, { mode: "multiple", showArrow: true, optionFilterProp: "children", value: useIdAsValue ? value : value === null || value === void 0 ? void 0 : value.map(jobArea => jobArea.id), defaultValue: useIdAsValue ? defaultValue : defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.map(jobArea => jobArea.id), filterOption: (input, option) => (0, normalize_string_1.normalizeStr)(option.children).indexOf((0, normalize_string_1.normalizeStr)(input)) >= 0, onChange: useIdAsValue ? onChange : onSelectChange, placeholder: intl.formatMessage({ id: 'global.job_area.placeholder' }), ...otherProps, children: jobAreas.map(jobArea => {
            // we need to pass string as children to option for using filterOption on Select search
            // if we pass <FormattedMessage.../> as children, search does not work
            const jobAreaName = intl.formatMessage({
                id: jobArea.translation_key,
            });
            return ((0, jsx_runtime_1.jsx)(Option, { value: jobArea.id, children: jobAreaName }, jobArea.id));
        }) }));
};
function JobAreaSelectField(props) {
    const { rules, useIdAsValue = true, label, name, dependencies, ...otherProps } = props;
    const intl = (0, react_intl_1.useIntl)();
    const [jobAreas, setJobAreas] = react_1.default.useState([]);
    const init = async () => {
        try {
            const jobAreasResponse = await Api.JobArea.getOfferJobAreas();
            setJobAreas(jobAreasResponse);
        }
        catch (err) {
            console.error(err);
            antd_1.notification.error({
                message: intl.formatMessage({ id: 'general.error' }),
                description: intl.formatMessage({ id: 'general.something_went_wrong' }),
            });
        }
    };
    react_1.default.useEffect(() => {
        init();
    }, []);
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: label, name: name, rules: rules, dependencies: dependencies, children: (0, jsx_runtime_1.jsx)(SelectFieldWrapper, { useIdAsValue: useIdAsValue, jobAreas: jobAreas, intl: intl, ...otherProps }) }));
}
